module.exports = __webpack_public_path__ + "img/zs-2.a3d16e7b.png";